import Immutable from 'immutable'
import createReducer from './createReducer'
import { actionTypes } from '../actions/searchAlertsAction'

const initialState = Immutable.fromJS({
  alerts: [],
  error: null,
  isLoading: false,
})

export default createReducer(initialState, {
  [actionTypes.AUTOMATED_REPORTS_REQUEST]: (state) =>
    state.merge(Immutable.fromJS({
      isLoading: true,
    })),
  [actionTypes.AUTOMATED_REPORTS_SUCCESS]: (state, { data }) =>
    state.merge(Immutable.fromJS({
      alerts: data.alerts,
      isLoading: false,
    })),
  [actionTypes.AUTOMATED_REPORTS_ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({
      error,
      isLoading: false,
    })),
  [actionTypes.REMOVE_AUTOMATED_REPORT_REQUEST]: (state, { data }) => {
    const alerts = state.get('alerts').map(alert => (
      alert.set('isBeingRemoved', alert.get('rtalert_cron_id') === data.id)
    ))

    return state.set('alerts', alerts)
  },
  [actionTypes.REMOVE_AUTOMATED_REPORT_SUCCESS]: state => state,
  [actionTypes.REMOVE_AUTOMATED_REPORT_ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({
      error,
    })),
})



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/searchAlertsReducer.js
 **/